import _ from 'underscore';
import { AuthService } from '../services/auth/auth.service';
import { Inject, Injectable } from '@angular/core';
import { URL_SUPPLIER_ACTIVATION_FORM } from './url-collections';
import { IExtendedWindow, IObject } from '@type_definitions/datatypes';
import { urlUtil } from '../util';

@Injectable()
export class UrlService {
  constructor(
    @Inject(Window) private window:IExtendedWindow,
    private authService:AuthService
  ) {
    /**/
  }

  public get urlParams():IObject {
    const url:string = this.window.location.hash.substr(1, this.window.location.hash.length);
    return urlUtil.getQueryParams(url);
  }

  public get bpMailToUrl():string {
    return '/unacc/MailView_Edit.jsp?ejbEvent=create&NormalMode=1&ViewName=P_Summary&Dewflty=BP&Deccoid={Deccoid}&Wvmaito={Deconid}&browseList=true';
  }

  public getImageUrl = (guid:string):string => `/ga2/images/${guid}`;
  public getAttachmentUrl = (fileId:number):string => `/unacc/AttachWriter?row0_Deattid=${fileId}`;

  public getSupplierActivationFormUrl(bpProfileIds:number | number[]):string {
    if (!_.isArray(bpProfileIds)) {
      bpProfileIds = [ bpProfileIds ];
    }
    const supplierActivationDownloadUrl:string = URL_SUPPLIER_ACTIVATION_FORM.replace('{bpIds}', _.uniq(bpProfileIds).join(','));
    return this.authService.authenticatedUrl(supplierActivationDownloadUrl);
  }

  public getProfilePictureUrl(userId:number, refresh?:boolean):string {
    let url:string = `rest/userman/userprofile/${userId}/profilepicture`;
    if (refresh) {
      url += `?r=${Date.now()}`;
    }
    return this.authService.authenticatedUrl(url);
  }
}